import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { AppContext } from 'store/AppContext';
import { getKosningarThatHaveAtkvaedi } from 'common/services/apiService';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function KosningSelect({setKosningId}) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const [kosningarList, setKosningarList] = useState([]);
  const [selectedKosningId, setSelectedKosningId] = useState('');

  useEffect(() => {
    async function fetchKosningarThatHaveAtkvaedi() {
      const { data, isSuccess, error } = await getKosningarThatHaveAtkvaedi(context, []);
      
      if (isSuccess) {
        setKosningarList(data);
        if (data.length === 1) {
          setSelectedKosningId(data[0].id);
          setKosningId(data[0].id);
        }
      } else {
        console.error(error);
      }
    };

    fetchKosningarThatHaveAtkvaedi();
  }, [context, setKosningId]);

  const handleChange = event => {
    setSelectedKosningId(event.target.value);
    setKosningId(event.target.value);
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="tolfraedi-kosning-select" shrink>
          Kosning
        </InputLabel>
        <Select
          labelId="tolfraedi-kosning-select-label"
          id="tolfraedi-kosning-select"
          value={selectedKosningId}
          displayEmpty={true}
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>Veljið kosningu</em>
          </MenuItem>
          {kosningarList.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.lysing}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}